import availableColors from './_overrides.module.scss';
import { createTheme } from '@fluentui/react';

export const myTheme = createTheme({
    //defaultFontStyle: { fontFamily: 'Monaco, Menlo, Consolas', fontWeight: 'regular' },
    defaultFontStyle: { fontFamily: `"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue"`, fontWeight: 'regular' },
    fonts: {
        small: {
            fontSize: '12px',
        },
        medium: {
            fontSize: '14px',
        },
        large: {
            fontSize: '20px',
            fontWeight: 'semibold',
        },
        xLarge: {
            fontSize: '22px',
            fontWeight: 'semibold',
        },
    },
    palette: {
        themePrimary: availableColors.primaryColor,
        themeLighterAlt: availableColors.primaryLighterAltColor,
        themeLighter: availableColors.primaryLighterColor,
        themeLight: availableColors.primaryLightColor,
        themeTertiary: availableColors.tertiaryColor,
        themeSecondary: availableColors.secondaryColor,
        themeDarkAlt: availableColors.primaryDarkAltColor,
        themeDark: availableColors.primaryDarkColor,
        themeDarker: availableColors.primaryDarkerColor,
        neutralLighterAlt: '#faf9f8',
        neutralLighter: availableColors.neutralLighter,
        neutralLight: availableColors.neutralLight,
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',

        
    }
});